export default __webpack_public_path__ + "static/media/about.0c10b846.svg";